import React from "react";

export default function MSAccess_Cos() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Cos</h1>
      <p>This is the MSAccess_Cos component generated from the SQL JSON.</p>
    </div>
  );
}
